import slickCarousel from 'slick-carousel';

var relatedContentSliders = document.querySelectorAll('.related-content');
var relatedContentSlidersLength = relatedContentSliders.length;
function initSlick() {
	for(i = 0; i < relatedContentSlidersLength; i++) {
		var thisId = relatedContentSliders[i].id;
		if(thisId) {
			var $st = $('#' + thisId + ' .pagination');
			$st.attr("style","");
			var $slickEl = $('#' + thisId + ' .center');
			$slickEl.on('init', function (event, slick, currentSlide, nextSlide) {
				setSlideCount(thisId,event, slick, currentSlide, nextSlide);
			});
			var sliderSlidesToShow = 2;
			var sliderSlideToStartOn = 1;
			var centerPadding769 = '30px';
			var centerPaddingFull = '100px';
			if($('#' + thisId + ' .related-content-treatments').length) {
				centerPadding769 = '0 30px 0 0';
				centerPaddingFull = '0 30px 0 0';
			}
			$slickEl.slick({
			  centerMode: true,
			  slidesToShow: 1,
			  infinite: false,
			  dots: true,
			  arrows: false,
			  initialSlide: 0,
	   		  centerPadding: '30px',
			  mobileFirst: true,
				responsive: [
					{
						breakpoint: 580,
						settings: {
							centerMode: false,
							centerPadding: centerPadding769,
							slidesToShow: 2
						}
					},
					{
						breakpoint: 960,
						settings: {
							centerPadding: centerPadding769,
							focusOnSelect: true,
							centerMode: false,
							slidesToShow: 3
						}
					},
					{
						breakpoint: 1024,
						settings: {
							centerPadding: centerPaddingFull,
							focusOnSelect: true,
							centerMode: false,
							slidesToShow: 4
						}
					}
			    ]
			});
		}
	} }
initSlick();


var reInitSlickOnResize = function () {
	var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
	for(var i = 0; i < relatedContentSlidersLength; i++) {
		var thisId = relatedContentSliders[i].id;
		if(thisId) {
			var $slickEl = $('#' + thisId + ' .center');
			if(browserZoomLevel <= 200) {
				if(!$slickEl.hasClass('slick-slider')) {
					initSlick();					
				} else {
					$slickEl[0].slick.refresh();
					$slickEl.slick('resize');					
				}
			} else {
				if($slickEl.hasClass('slick-slider')) {
					unslickify(thisId);
				}
			}
		}
	}
};

$(window).on('load resize orientationchange', reInitSlickOnResize);

$('.related-content .slider').on('reInit afterChange', function (event, slick, currentSlide, nextSlide) {
	var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
	var thisId = $(this).closest('.related-content').attr('id');
	var thisSlickTrack = $(this).find('.slick-track');
	var thisSlickTrack = $(thisSlickTrack).removeClass('loaded');
	setSlideCount(thisId,event, slick, currentSlide, nextSlide);
});

function setSlideCount(thisId,event, slick, currentSlide, nextSlide) {
	var i = (currentSlide ? currentSlide : 0) + 1;
	var $st = $('#' + thisId + ' .pagination');
	$st.text(i + ' of ' + slick.slideCount);
 }


var unslickify = function(thisId) {
	var thisEl = $('#' + thisId);
	var $slickEl = $('#' + thisId + ' .center');
	var slickcards = $slickEl.find('.card');
	$slickEl.clone().removeClass('slick-initialized slick-slider slick-dotted').addClass(thisId).empty().prependTo(thisEl);
	var newParentDiv = $('#' + thisId + ' .center:not(.slick-slider)');
	for(var u=0;u<slickcards.length;u++) {
		$(slickcards[u]).clone().appendTo(newParentDiv);
	}
	$slickEl.slick('unslick').remove();
	$(thisEl).find('.pagination').hide();
};
